var $a07188a3e3e0c31e$exports = {};
$a07188a3e3e0c31e$exports = {
    "endTime": `Sluttidspunkt`,
    "startTime": `Starttidspunkt`,
    "time": `Klokkesl\xe6t`
};


export {$a07188a3e3e0c31e$exports as default};
//# sourceMappingURL=da-DK.mjs.map
